import { __awaiter, __rest } from "tslib";
import apiClient from './apiClient';
export function unsubscribe(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        const { token } = payload, extraPayload = __rest(payload, ["token"]);
        const { data } = yield apiClient.post('/engage/v1/unsubscribe', extraPayload, {
            params: {
                token,
            },
        });
        return data;
    });
}
export default {
    unsubscribe,
};
